// Ported from teacher_web_app's noteFormatting.ts — keep the marker set in sync if that file changes.

const ALIGN_RE = /^\[\[align:(left|center|right|justify)\]\]/;

export function parse_align(text) {
  const match = (text || '').match(ALIGN_RE);
  if (!match) return { align: 'left', body: text || '' };
  return { align: match[1], body: text.slice(match[0].length) };
}

const INLINE_RE = /\*\*(.+?)\*\*|\+\+(.+?)\+\+|__(.+?)__/g;

// Single-level tokenizer: no nesting, matching what the toolbar can produce.
export function parse_inline(body) {
  const tokens = [];
  let last = 0;
  let match = INLINE_RE.exec(body);
  while (match) {
    if (match.index > last) tokens.push({ mark: null, text: body.slice(last, match.index) });
    if (match[1] !== undefined) tokens.push({ mark: 'bold', text: match[1] });
    else if (match[2] !== undefined) tokens.push({ mark: 'underline', text: match[2] });
    else tokens.push({ mark: 'italic', text: match[3] });
    last = INLINE_RE.lastIndex;
    match = INLINE_RE.exec(body);
  }
  if (last < body.length) tokens.push({ mark: null, text: body.slice(last) });
  return tokens;
}
